<template>


<div style="margin: 5px;">
       <InputGroup>
    <InputGroupAddon>加簽人員(內部人員)</InputGroupAddon>
    <InputText placeholder=""  
        :class="{'p-invalid': isError}" 
        v-model="value" :disabled="disabled"
        @change="PassApprovalStaff()" />
    
</InputGroup>
</div>

   <!--  <div class="textbox">
        <label>加簽人員(內部人員)</label>
        <InputText placeholder=""  
        :class="{'p-invalid': isError}" 
        v-model="value" :disabled="disabled"
        @change="PassApprovalStaff()" />
    </div> -->
</template>  
<script>

import Service from "../../service/service";
import EFormService from "../../service/EFormService";
export default {
    props: ["modelValue", 'disabled'],
    emits: ["update:modelValue"],
    components: {

    },
    data() {
        return {
            value :'',
            valueError:false,
            
        }
    },
    Service: null,
    EFormService: null,
    created() {
        this.value = this.modelValue
        this.Service = new Service();
        this.EFormService = new EFormService();
    },
    watch: {
            modelValue: function () {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            },
            value: function (newVal,) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
    computed: {
        isError() {
            return  !this.disabled && (!this.value || (this.value && this.value.includes('@')) || this.valueError==true)      ;
        },
    },
   methods: {
        PassApprovalStaff() {

            this.displaySpin = ""
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.displaySpin = "none"
                this.CheckApprovalStaff();
                this.$emit('update:ApprovalStaff_outside', this.ApprovalStaff);
            }, 1000);
        },
        CheckApprovalStaff() {
            let self=this;
            self.isDisplaySpin=true;
            this.EFormService.CheckADArray(this.value).then((data) => {
              let chk=data;
              let noExist = chk.some(x=>x.IsExist==false);
              if(noExist){

                let lstNoExist = chk.filter(x=>x.IsExist==false);
                let lstNoExistAD =lstNoExist.map(x=>x.AD);
                let text = lstNoExistAD.join(',');

                this.$toast.add({
                    severity: 'error', summary: 'error Message', detail: text + ':查無該人員', life: 3000
                });

                this.valueError=true;
                self.isDisplaySpin=false;
              }
              else {
                this.valueError=false;
                self.isDisplaySpin=false;
                self.$emit('update:modelValue', self.value);
              }

            })
        }
    }
}
</script>
  
  